import type {CurrencyConfig} from '../types'

const currencies: CurrencyConfig[] = [
  {value: 'USD', label: 'USD', formatLocale: 'en-US'},
  {value: 'EUR', label: 'EUR', formatLocale: 'de-DE'},
  {value: 'GBP', label: 'GBP', formatLocale: 'en-GB'},
  {value: 'CAD', label: 'CAD', formatLocale: 'en-US'},
  {value: 'AUD', label: 'AUD', formatLocale: 'en-US'},
  {value: 'CHF', label: 'CHF', formatLocale: 'de-CH'},
  {value: 'NOK', label: 'NOK', formatLocale: 'nb-NO'},
  {value: 'JPY', label: 'JPY', formatLocale: 'ja-JP'},
  {value: 'ILS', label: 'ILS', formatLocale: 'he-IL'},
]

const config = {
  currencies,
}

export default config
